var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('vue-loading'):_c('div',[_c('h1',[_vm._v(_vm._s(_vm.room.roomName))]),_vm._v(" "),(_vm.room.roomId != null)?_c('item-list',{attrs:{"roomId":_vm.room.roomId}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aace82d","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Room.vue
// module id = 458
// module chunks = 4